import { styled } from '@/styled-system/jsx';

// TypeScript interfaces for component props
export interface OfferTextProps {
  bold?: boolean;
}

// Base column styling for layout
export const OffersColumn = styled('div', {
  base: {
    display: 'inline-block',
    marginTop: '2x',
    marginBottom: '2x',
    marginLeft: '0',
    marginRight: '0',
  },
});

// Icon column with specific width and alignment
export const IconColumn = styled('div', {
  base: {
    display: 'inline-block',
    marginTop: '2x',
    marginBottom: '2x',
    marginLeft: '0',
    marginRight: '0',
    verticalAlign: 'top',
    width: '36px',
    paddingLeft: '12px',
    paddingRight: '1x',
  },
});

// Main container with Container-like styling
export const SpecialOffersContainer = styled('div', {
  base: {
    paddingTop: '3x',
    marginBottom: '1x',
    // Container component styling will be applied via wrapping
  },
});

// PromoIcon is now handled by the inline SVG component

// Container for special offer content with critical rendering optimizations
export const SpecialOfferContainer = styled('div', {
  base: {
    borderStyle: 'solid',
    borderRadius: '4px',
    padding: '0',
    marginTop: '2x',
    marginRight: '2x',
    marginBottom: '0',
    marginLeft: '2x',
    // Critical rendering optimizations for LCP element
    willChange: 'transform',
    transform: 'translateZ(0)', // Force GPU layer for faster paint
  },
  variants: {
    isSpecialOffersExperiment: {
      true: {
        backgroundColor: 'rgba(253, 231, 134, 0.5)',
        borderWidth: '1px',
        borderColor: 'hpxYellow400',
      },
      false: {
        backgroundColor: 'rgba(218, 242, 240, 0.25)',
        borderWidth: '0.5px',
        borderColor: 'hpxTeal100',
      },
    },
  },
});

// Text column with calculated width
export const OfferTextColumn = styled('div', {
  base: {
    display: 'inline-block',
    marginTop: '2x',
    marginBottom: '2x',
    marginLeft: '0',
    marginRight: '0',
    paddingRight: '36px',
    width: 'calc(100% - 36px)',
  },
});

// Container for individual offer details with CSS optimizations
export const OfferDetails = styled('div', {
  base: {
    paddingBottom: '2x',
    '&:last-child': {
      paddingBottom: '0',
    },
    // Use CSS selector to style first offer's first text as bold
    '&:first-child span:first-child': {
      fontWeight: 'bold',
    },
  },
});

// Text component optimized with CSS selectors
export const OfferText = styled('span', {
  base: {
    fontSize: 'sm',
    lineHeight: 'tiny',
    color: 'hpxBlue700',
  },
  variants: {
    bold: {
      true: {
        fontWeight: 'bold',
      },
    },
  },
});
